module.exports = __webpack_public_path__ + "img/核心业务banner1920x280px.d2895a85.png";